'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var DrawerContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  min-width: ", ";\n\n  max-width: ", ";\n\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"], ["\n  min-width: ",
    ";\n\n  max-width: ",
    ";\n\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])), function (props) {
    return props.minWidth ? props.minWidth + "rem" : '30rem';
}, function (props) {
    return props.maxWidth ? props.maxWidth + "rem" : 'none';
});
var FooterContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  background-color: white;\n  width: 100%;\n  flex-grow: 0;\n"], ["\n  background-color: white;\n  width: 100%;\n  flex-grow: 0;\n"])));
var HeaderContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  background-color: white;\n  width: 100%;\n  flex-grow: 0;\n"], ["\n  background-color: white;\n  width: 100%;\n  flex-grow: 0;\n"])));
var ChildrenContainter = styled__default.div(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  overflow: auto;\n  height: 100%;\n  flex-grow: 1;\n"], ["\n  overflow: auto;\n  height: 100%;\n  flex-grow: 1;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.ChildrenContainter = ChildrenContainter;
exports.DrawerContainer = DrawerContainer;
exports.FooterContainer = FooterContainer;
exports.HeaderContainer = HeaderContainer;
